import { FC } from 'react';
import { Account } from 'shared/types/account';
import { useFormat } from 'helpers/hooks/useFormat';
import InfoCard from '../../../account-atoms/info-card';

interface PersonalInformation {
  account: Account;
}

const PersonalInfo: FC<PersonalInformation> = ({ account }) => {
  const { formatMessage } = useFormat({ name: 'common' });
  const { formatMessage: formatAccountMessage } = useFormat({ name: 'account' });

  const personalInformationFields: Array<{ label: string; value: string }> = [
    {
      label: formatMessage({ id: 'title', defaultMessage: 'Title' }),
      value: account?.title || '',
    },
    { label: formatMessage({ id: 'firstName', defaultMessage: 'First Name' }), value: account?.firstName as string },
    { label: formatMessage({ id: 'lastName', defaultMessage: 'Last Name' }), value: account?.lastName as string },
    { label: formatMessage({ id: 'email', defaultMessage: 'Email' }), value: account?.email },
    {
      label: formatMessage({ id: 'dateOfBirth', defaultMessage: 'Date of Birth' }),
      value: account?.birthday
        ? new Date(account?.birthday || '').toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })
        : ``,
    },
  ];

  return (
    <InfoCard
      title={formatAccountMessage({ id: 'personal.info', defaultMessage: 'Personal information' })}
      isEditable
      infoFields={personalInformationFields}
      editHref="?id=edit-personal-info"
    />
  );
};

export default PersonalInfo;
